import React from "react";
import { Col, Divider, Form, Input, Modal, Row, Select, theme } from "antd";
import useDropdownItem from "../../common/useDropdownItem";
import ErrorMessages from "../../common/ErrorMessages";
import { URL_USER } from "../../constants/urls";
import { PATCH, POST } from "../../frameworks/HttpClient";

export default function UserManageModal(props) {
  const { target, open, onClose, onUpdate } = props;
  const [errorMessages, setErrorMessages] = React.useState(null);
  const [loading, setLoading] = React.useState(null);
  const [form] = Form.useForm();
  const isCreate = target === 'add'
  const {
    token: { colorWarning, colorSuccess },
  } = theme.useToken();

  const userGroupDropdown = useDropdownItem({ manual : true, url: URL_USER.GROUP, label: 'name', value:'name', pagination: true, params: { page_size: 999 } })
  
  const handleSave = async() => {
    setLoading(true);
    setErrorMessages(null);
    try {
      const data = await form.validateFields();
      if(isCreate){
        await POST(URL_USER.USER, data)
        onUpdate();
      } else {
        await PATCH(`${URL_USER.USER}${target.id}/`, data)
        onUpdate();
      }
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false)
    }
  }

  React.useEffect(() => {
    if(open){
      userGroupDropdown.fetchOptions();
      form.setFieldsValue(target);
    } else {
      form.resetFields();
    }
  },[open])

  return(
    <Modal
      open={open}
      title={isCreate ? "สร้างผู้ใช้งาน" : "แก้ไขผู้ใช้งาน"}
      onCancel={onClose}
      onOk={handleSave}
      okText={"เพิ่ม"}
      cancelText={"ปิด"}
      okButtonProps={{ style: { backgroundColor : isCreate ? colorSuccess : colorWarning}, loading : loading }}
    >
      <ErrorMessages message={errorMessages}/>
      	<Form
					form={form}
          layout="vertical">
          <Row>
            <Col span={12}>
              <Form.Item 
                label={'ชื่อ'} 
                name={"first_name"}
                style={{marginRight : 10}}
                rules={[{ required : true, message: 'กรุณากรอกข้อมูล' }]}
              >
                <Input style={{ width : '100%' }} placeholder={'ชื่อ'} autoComplete="off"/>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item 
                label={'นามสกุล'} 
                name={"last_name"}
                rules={[{ required : true, message: 'กรุณากรอกข้อมูล' }]}
              >
                <Input style={{ width : '100%' }} placeholder={'นามสกุล'} autoComplete="off"/>
              </Form.Item>
            </Col>
          </Row>
          <Form.Item 
              label={'ตำแหน่งงาน'} 
              name={"groups"}
              rules={[{ required : true, message: 'กรุณากรอกข้อมูล' }]}
            >
              <Select mode="multiple" style={{ width : '100%' }} placeholder={'ตำแหน่งงาน'} autoComplete="off" options={userGroupDropdown.options}/>
          </Form.Item>
          {isCreate && 
            <div>
              <Divider>บัญชีผู้ใช้งาน</Divider>
              <Form.Item
                label={"ชื่อผู้ใช้งาน"}
                name={"username"} 
                rules={[
                {
                  required: true,
                  message: 'กรุณากรอกรหัสผ่านใหม่!',
                },
              ]}>
                <Input placeholder={'ชื่อผู้ใช้งาน'}/>
              </Form.Item>
              <Form.Item
                label={"รหัสผ่านใหม่"}
                name={"password"} 
                rules={[
                {
                  required: true,
                  message: 'กรุณากรอกรหัสผ่านใหม่!',
                },
              ]}>
                <Input.Password placeholder={'รหัสผ่านใหม่'}/>
              </Form.Item>
              <Form.Item
                label={"ยืนยันรหัสผ่านใหม่"}
                name={"confirm_password"} 
                dependencies={['password']}
                hasFeedback
                rules={[          
                  {
                    required: true,
                    message: 'กรุณายืนยันรหัสผ่านใหม่!',
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('password') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('รหัสผ่านทั้งสองไม่ตรงกัน กรุณาตรวจสอบใหม่อีกครั้ง!'));
                    },
                  }),
              ]}>
                <Input.Password placeholder={'ยืนยันรหัสผ่านใหม่'}/>
              </Form.Item>
              </div>
            }
        </Form>
    </Modal>
  )
}